import { render, staticRenderFns } from "./AnswerYesNo.vue?vue&type=template&id=de659f70&"
import script from "./AnswerYesNo.vue?vue&type=script&lang=js&"
export * from "./AnswerYesNo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports